import { FeatureCard } from '@/components/feature-card';
import { SimulationCard } from '@/components/simulation-card';
import { Text } from '@/components/text';
import { AnimatedView, View } from '@/components/ui/tw-wrappers';
import { SCREEN_MAX_WIDTH } from '@/constants/layout';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { StyleSheet, useWindowDimensions } from 'react-native';
import Animated, { FadeInUp } from 'react-native-reanimated';

const AnimatedText = Animated.createAnimatedComponent(Text);

interface HeroSectionProps {
  totalHeight: number;
}

export function HeroSection({ totalHeight }: HeroSectionProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const { height: windowHeight } = useWindowDimensions();

  const dynamicMainStyle = { minHeight: windowHeight - totalHeight };

  return (
    <View style={[styles.mainContainer, dynamicMainStyle]} className='pt-0 md:pt-6'>
      <View className='z-1 w-full self-center' style={{ maxWidth: SCREEN_MAX_WIDTH }}>
        <View className='gap-6 p-6 md:gap-11'>
          <AnimatedText
            entering={FadeInUp.delay(200).duration(800).springify()}
            className='text-left text-[32px] font-bold leading-[36px] md:text-[38px] md:leading-[50px]'
            style={{ fontFamily: 'Lexend-Bold' }}>
            {t('home.hero.title')}
          </AnimatedText>
          <AnimatedView
            className='w-full flex-col gap-6 md:flex-row md:items-stretch'
            entering={FadeInUp.delay(400).duration(800).springify()}>
            <FeatureCard
              icon='calculator.fill'
              title={t('home.features.earnings.title')}
              description={t('home.features.earnings.description')}
            />
            <FeatureCard
              icon='shield.fill'
              title={t('home.features.enablement.title')}
              description={t('home.features.enablement.description')}
            />
            <FeatureCard
              icon='bolt.fill'
              title={t('home.features.results.title')}
              description={t('home.features.results.description')}
            />
          </AnimatedView>
          <AnimatedView
            className='w-full max-w-[980px] flex-col gap-8 mb-6 md:items-stretch'
            entering={FadeInUp.delay(800).duration(800).springify()}>
            {/* <Text className='text-base text-primary leading-6 md:leading-7'>{t('home.hero.subtitle')}</Text> */}
            <View className='flex-col gap-6  md:flex-row md:items-stretch md:w-3/4'>
              <AnimatedView className='flex-1' entering={FadeInUp.delay(900).duration(800).springify()}>
                <SimulationCard
                  title={t('home.hero.comparison.title')}
                  description={t('home.hero.comparison.description')}
                  buttonLabel={t('home.hero.cta')}
                  onPress={() => router.push('/compare')}
                />
              </AnimatedView>
              <AnimatedView className='flex-1' entering={FadeInUp.delay(1000).duration(800).springify()}>
                <SimulationCard
                  title={t('home.hero.benchmarking.title')}
                  description={t('home.hero.benchmarking.description')}
                  buttonLabel={t('home.hero.cta')}
                  onPress={() => router.push('/benchmarking')}
                />
              </AnimatedView>
            </View>
          </AnimatedView>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  mainContainer: {
    paddingTop: 40,
  },
});
